import LbsSdk from '@adsk/lbs-sdk-js';

import {getLBSContainerId} from '../selectors';
import {getCookie} from '../../utils/cookie';
import {
  willReadLocationTree,
  readLocationTreeSuccess,
  readLocationTreePaginationFinished,
  readLocationTreeFailure
} from '../actions/lbs-actions';
import {LBS_PAGE_SIZE} from '../../constants/lbs';
import {getToken} from '../../utils/getToken';
import {ENV_CONFIGS} from '../../constants/envs';

/**
 * Create instance of LbsSdk and passes tokens for configuration
 * @param getAccessToken - method that returns a promise for getting access token for Apigee
 * @param lbsSdkConfig - LBS SDK config
 */
const instantiateLbsSdk = (getAccessToken, lbsSdkConfig) =>
  new LbsSdk({
    getCsrfToken: () => getCookie('CSRF-TOKEN'),
    getAccessToken,
    ...lbsSdkConfig
  });

/**
 * A class of static thunk functions for locations
 */
export default class LocationsThunk {
  /**
   * * Gets all nodes of a certain tree
   * @param id - an lbs sdk tree instance
   * @param offset  - page offset
   * @returns {function(*, *)}
   */
  static getTree(id, offset = 0) {
    return (dispatch, getState) => {
      const state = getState();
      const lbsContainerId = getLBSContainerId(state);
      const getAccessToken = () => getToken({dispatch, getState});
      const lbsSdkConfig = ENV_CONFIGS.LBS_SDK_CONFIG;

      const lbsSdk = instantiateLbsSdk(getAccessToken, lbsSdkConfig);
      dispatch(willReadLocationTree(lbsContainerId, id));

      return lbsSdk
        .getNode(lbsContainerId, id)
        .getTreeNodesPage(LBS_PAGE_SIZE, offset)
        .then(payload => {
          dispatch(readLocationTreeSuccess(payload));
          if (payload.pagination.nextUrl) {
            // We need all locations tree to show location picker - so if we have next page we request it here.
            return LocationsThunk.getTree(id, offset + LBS_PAGE_SIZE)(dispatch, getState);
          } else {
            // no more pages to load
            dispatch(readLocationTreePaginationFinished());
          }
          return payload;
        })
        .catch(error => dispatch(readLocationTreeFailure(error)));
    };
  }

  /**
   * Gets the container default tree with its nodes
   * @return {function(*=, *=)}
   */
  static getDefaultTree() {
    const paramForDefaultTree = 'default';

    return (dispatch, getState) => LocationsThunk.getTree(paramForDefaultTree)(dispatch, getState);
  }
}
